export const DEFAULT_LOCALE = "en-US";

export const AVAILABLE_GROUPS = [
    { label: 'Admin', value: 'admin' },
    { label: 'Alarms', value: 'alarms' },
    { label: 'CM', value: 'cm' },
    { label: 'CS', value: 'cs' },
    { label: 'CSIR', value: 'csir' },
    { label: 'Events', value: 'events' },
    { label: 'Alarms Supervisor', value: 'alarms-sup' },
    { label: 'CM Supervisor', value: 'cm-sup' },
    { label: 'CS Supervisor', value: 'cs-sup' },
    { label: 'CSIR Supervisor', value: 'csir-sup' },
    { label: 'Events Supervisor', value: 'events-sup' },
    { label: 'OIM', value: 'oim' },
    { label: 'ODP/IGI/BI', value: 'odp-igi-bi' },
    { label: 'Super Author', value: 'super-author' }
];

export const SERVICE_LINES = [
    // { name: 'All Groups', value: 'all' },
    { name: 'CSIR', value: 'csir' },
    { name: 'Alarms', value: 'alarms' },
    { name: 'Customer Service', value: 'cs' },
    { name: 'Events', value: 'events' },
    { name: 'Crisis Management', value: 'cm' },
];

